import {ValueObject} from '@s-ui/domain'

import {SeoScriptValueObject} from './SeoScriptValueObject.js'

export class ListSeoScriptValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new ListSeoScriptValueObject({value: value.map(SeoScriptValueObject.create)})
  }

  get value() {
    return this.#value.map(script => script.value)
  }

  toJSON() {
    return {value: this.#value.map(script => script.toJSON())}
  }
}
